<template>
  <div class="growup-record-setting">
    <div class="main-wrapper">
      <div class="option-wrapper">
        <div v-for="item in list" :key="item.index">
          <div class="option-item van-hairline--bottom" v-if="!item.deleted">
            <div @click="deleteItem(item)">
              <van-icon
                class-prefix="vxs-icon"
                name="system_del"
                color="var(--c3)"
              />
            </div>
            <div class="option-name">
              <van-field
                v-model="item.name"
                placeholder="请输入类型名称，8个字以内"
                maxlength="8"
                clearable
                :readonly="!!item.id"
                :formatter="v => v.trimLeft()"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="add-item" @click="addItem" v-if="len < 99">
        <van-icon class-prefix="vxs-icon" name="system_add" size="var(--fs-md)" color="var(--c1)" />新增成长记录类型
      </div>
      <div class="reminder" v-else>最多添加99个成长记录类型</div>
    </div>
    <page-footer-btn
      @click="submit"
      btnText="确定"
      :loading="btnLoading"
      loading-text="提交中..."
    />
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';
let count = 0;

export default {
  data() {
    return {
      pageTitle: '成长记录类型设置',
      // isDefaultEdit: false, // 是否默认维度的编辑
      list: [],
      btnLoading: false,
    };
  },
  computed: {
    len() {
      return this.list.filter(item => !item.deleted).length;
    },
  },
  methods: {
    addItem() {
      this.list.push({ name: '', index: ++count });
    },
    async deleteItem(item) {
      if (item.id) {
        const c = await this.$dialog
          .confirm({
            message: `删除后，只删除该类型，不会删除已有成长记录，确认删除该类型吗？`,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          })
          .catch(() => {});
        if (!c) {
          return;
        }
        this.list = this.list.map(it => {
          if (it.index === item.index) {
            it.deleted = true;
          }
          return it;
        });
      } else {
        this.list = this.list.filter(it => it.index !== item.index);
      }
    },
    verify() {
      let flag = true;
      for (const it of this.list) {
        if (!it.name.trim()) {
          this.$toast('请输入类型名称');
          flag = false;
          break;
        }
      }
      return flag;
    },
    emitAfterSave() {
      // 完成后向列表页面触发事件
      app.vue.$emit('refresh-growup-record');
      // }
      this.$router.back();
    },
    submit() {
      if (!this.verify()) return;
      this.btnLoading = true;
      this.$api
        .archivesTypeAdd({
          baseArchivesTypeList: this.list,
          type: 1,
        })
        .then(res => {
          if (res.code === 200) {
            this.$toast.success('新增成功');
            // app.vue.$emit('add-price-dimension', {
            //   id: res.data.id,
            //   dimensionName: res.data.dimensionName,
            //   basePriceDimensionDetailList: res.data.basePriceDimensionDetailList,
            // });
            this.emitAfterSave();
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
  },
  created() {
    this.$api
      .archivesTypeList({
        type: 1,
        page: {
          pageNum: 1,
          pageSize: 100,
        },
      })
      .then(res => {
        if (res.code === 200) {
          this.list = res.data.map(item => {
            item.index = count++;
            return item;
          });
        }
      });
  },
  components: {
    pageFooterBtn,
  },
};
</script>

<style lang="scss" scoped>
.growup-record-setting {
  background-color: var(--g1);
  display: flex;
  flex-direction: column;
  .main-wrapper {
    flex: 1;
    overflow-y: scroll;
    .add-item {
      padding: calc(var(--gap) * 16);
      color: var(--c1);
      background-color: var(--white);
      i {
        margin-right: calc(var(--gap) * 6);
      }
    }
    .reminder {
      color: var(--g6);
      padding: calc(var(--gap) * 8) calc(var(--gap) * 16);
    }
    .option-wrapper {
      padding: 0 calc(var(--gap) * 16);
      background-color: var(--white);
      .option-item {
        display: flex;
        align-items: center;
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        box-sizing: content-box;
        .option-name {
          flex: 1;
        }
        .option-btn {
          font-size: 24px;
          & > span {
            display: inline-block;
            width: 24px;
            height: 24px;
            margin-left: calc(var(--gap) * 8);
          }
        }
      }
    }
  }
}
</style>
